import { render, staticRenderFns } from "./ClientEmploymentDietyPopUp.vue?vue&type=template&id=72da6c34&scoped=true&"
import script from "./ClientEmploymentDietyPopUp.vue?vue&type=script&lang=js&"
export * from "./ClientEmploymentDietyPopUp.vue?vue&type=script&lang=js&"
import style0 from "./ClientEmploymentDietyPopUp.vue?vue&type=style&index=0&id=72da6c34&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72da6c34",
  null
  
)

export default component.exports